// extracted by mini-css-extract-plugin
module.exports = {"side":"ComparisonPredicateEditor_side__dYw50","fixedType":"ComparisonPredicateEditor_fixedType__3-6b3"};